import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { Subject, takeUntil } from 'rxjs';
import { TimesheetService } from 'src/app/_services/timesheet.service';
import { BaseComponent } from '../../components/base/base.component';
import { UtilityService } from 'src/app/_services/utility.service';

@Component({
  selector: 'app-modal-note-timesheet',
  templateUrl: './modal-note-timesheet.component.html',
  styleUrls: ['./modal-note-timesheet.component.css']
})
export class ModalNoteTimesheetComponent
  extends BaseComponent
  implements OnInit
{
  // questo sarà l'oggetto ricevuto in input ogni volta che chiameremo la funzione openModal
  readonly modalData: any = inject(NZ_MODAL_DATA);
  formTimesheetNote: FormGroup;

  private readonly _modalRef: NzModalRef = inject(NzModalRef);
  private readonly _timesheetService: TimesheetService =
    inject(TimesheetService);
  public readonly _utilityService: UtilityService = inject(UtilityService);

  private readonly destroy$: Subject<void> = new Subject();

  constructor() {
    super();
  }

  ngOnInit() {
    this._initFormTimesheetNote();
  }

  /**
   * Metodo che serve per inizializzare il form
   */
  _initFormTimesheetNote() {
    this.formTimesheetNote = new FormGroup({
      note: new FormControl(this.modalData.note, Validators.required)
    });
  }

  /**
   * Metodo che richiama l'API per salvare le note giornaliere
   */
  saveNote() {
    this._timesheetService
      .saveNote(this.modalData.date, this.formTimesheetNote.value.note)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.responseToast('success', res.message);
          this.closeModal('success');
        },
        error: (err: any) => {
          this.responseToast('error', err.error.message);
        }
      });
  }

  /**
   * Metodo che serve per chiudere la modale
   */
  closeModal(event?: any) {
    this._modalRef.close(event);
  }
}
